export class WebStatusSeguradora {
    idConfigAdesao : number;
    idStatus : number;
}